import sdkUrl from "@/api/sdkurl";

//域名
const domain = "https://mengyuwan.cn";
const webConfig =  {
    //应用名称
    appName: "梦遇玩",
    //应用名称
    gameAppName: "梦遇玩",
    //网页title
    webTitle: "梦遇玩",
    //应用图标
    logoUrl: require("@/assets/logo.png"),
    //圆形logo
    logoRoundUrl: require("@/assets/logo-round.png"),
    //微信公众号
    wechatUrl: require("@/assets/gzh.jpg"),
    //应用二维码
    appqrUrl: "",
    //icp备案
    icp: "冀ICP备2024067940号-10",
    //公安备案
    publicSecurity: "",
    //版权所有
    copyright: "copyright © 2026 mengyuwan.cn All Rights Resered.",
    //公司地址
    address: "河北省石家庄市裕华区塔南路192号综合服务楼4楼A区25",
    //公司名称
    companyName: "石家庄新玩网络科技有限公司",
    //公司名称
    copyrightCompany: "梦遇玩平台 版权所有",
    //app备案
    appRecord: "",
    //用户协议
    agreement :  domain + "/static/agreement/user.html",
    //隐私政策
    privacy :  domain + "/static/agreement/privacy.html",
    //QQ客服
    qqkfList: [
         //{"info": "1416991369", "worktime": ""}
    ],
    wxkfList: [
        {"info": "https://work.weixin.qq.com/kfid/kfc1605a965d9dcdb6b", "worktime": "09:00-22:00"}
    ],
    telkfList: [
        // {"info": "", "worktime": ""}
    ],
    //平台币名称
    coinName: "平台币",
    bindCoinName: '绑币',
    //游戏加速器地址
    speedUrl: domain + "/static/speed/a.html?genCode=true",
    //sdkweb地址
    sdkUrl: sdkUrl,
    //默认搜索游戏名
    defaultSearchName: "斗罗大陆",
    hotSearchName: ["斗罗大陆"],
    redirectUri: domain + "/#/rechargeWeiXin",
    appid: "wx4d86611b3f48c5e7",
    drawUrl: domain + '/welfare/',
    gameUrlMiddle: "/h5/",
}

export default webConfig